import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { isDefined } from '@trimble-gcs/common';
import { ModusButtonModule, ModusIconModule, ModusTooltipModule } from '@trimble-gcs/modus';
import { CANCEL_BUTTON, DialogData, OK_BUTTON } from './dialog.model';
import { dialogTranslations } from './dialog.translations';

@Component({
  imports: [ModusIconModule, ModusButtonModule, ModusTooltipModule, MatDialogModule],
  templateUrl: './dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogComponent {
  private readonly dialogRef = inject(MatDialogRef<DialogComponent, boolean>);
  readonly data: DialogData = inject(MAT_DIALOG_DATA);

  readonly translations = dialogTranslations();

  readonly cancelButtonText = computed(() => {
    const { cancelButton } = this.data;

    if (isDefined(cancelButton)) {
      return cancelButton === CANCEL_BUTTON
        ? this.translations.cancelButton.text
        : cancelButton.text; // caller should have translated
    }

    return '';
  });

  readonly okButtonText = computed(() => {
    const { okButton } = this.data;

    // prettier-ignore
    return okButton === OK_BUTTON
      ? this.translations.okButton.text
      : okButton.text; // caller should have translated
  });

  cancelClick(): void {
    this.dialogRef.close(false);
  }

  okClick(): void {
    this.dialogRef.close(true);
  }
}
